var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_21719",
    "data-name": "Group 21719",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10.319,
    height: 12.872,
    viewBox: "0 0 10.319 12.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4369",
    "data-name": "Rectangle 4369",
    width: 10.319,
    height: 12.872,
    fill: "#0004ec"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21718",
    "data-name": "Group 21718",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13694",
    "data-name": "Path 13694",
    d: "M76.8,0a1.5,1.5,0,0,1,.424.212A1,1,0,0,1,77.614,1c0,.4,0,.8,0,1.205q0,3.673,0,7.346a1.028,1.028,0,0,1-.572.971,1.006,1.006,0,0,1-.46.109.368.368,0,0,1-.363-.335.374.374,0,0,1,.3-.4c.045-.01.091-.013.136-.024a.267.267,0,0,0,.218-.257c0-.05,0-.1,0-.151q0-4.156,0-8.313a1.58,1.58,0,0,0,0-.163A.272.272,0,0,0,76.62.736a1.229,1.229,0,0,0-.138,0H70.643a.287.287,0,0,0-.319.282.431.431,0,0,1-.121.269.366.366,0,0,1-.618-.25,1.027,1.027,0,0,1,.671-.98C70.3.036,70.35.018,70.4,0Z",
    transform: "translate(-67.297)",
    fill: "#0004ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13695",
    "data-name": "Path 13695",
    d: "M0,73.227q0-2.141,0-4.282a1.01,1.01,0,0,1,.78-1.01,1.368,1.368,0,0,1,.335-.04h5.8A1.05,1.05,0,0,1,8,68.689a1.023,1.023,0,0,1,.028.274q0,4.257,0,8.514a1.018,1.018,0,0,1-1.061,1.059q-2.951,0-5.9,0A1.02,1.02,0,0,1,0,77.459q0-2.116,0-4.232m.738-.014q0,2.072,0,4.145c0,.059,0,.117,0,.176a.273.273,0,0,0,.248.257,1.268,1.268,0,0,0,.151,0h5.74a1.436,1.436,0,0,0,.151,0,.275.275,0,0,0,.254-.252,1.482,1.482,0,0,0,0-.163q0-4.157,0-8.315a1.341,1.341,0,0,0,0-.163.275.275,0,0,0-.2-.238.609.609,0,0,0-.211-.024H1.153a.655.655,0,0,0-.211.022.265.265,0,0,0-.2.235,1.708,1.708,0,0,0-.006.188q0,2.066,0,4.132",
    transform: "translate(0 -65.664)",
    fill: "#0004ec"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.5adfed42bc23d8cd06900ab5e72f7961.svg";
export { ForwardRef as ReactComponent };